import { createClient } from '@supabase/supabase-js';
import { authRefreshManager } from './authRefreshManager';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://demo.supabase.co';
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  'demo-key';

const isDemoMode = !import.meta.env.VITE_SUPABASE_URL ||
                   !supabaseAnonKey ||
                   supabaseAnonKey === 'demo-key' ||
                   import.meta.env.VITE_SUPABASE_URL === 'https://demo.supabase.co';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: !isDemoMode,
    autoRefreshToken: false,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'X-Client-Info': 'footypicks-web',
    },
  },
  db: {
    schema: 'public',
  },
  realtime: {
    params: {
      eventsPerSecond: 2,
    },
  },
});

if (!isDemoMode && typeof window !== 'undefined') {
  authRefreshManager.initialize(supabase);
}

export { isDemoMode };

export type { Database, Json } from '../types/database';
